import { render, staticRenderFns } from "./ServiceSummary.vue?vue&type=template&id=bf6bcc1a&scoped=true&"
import script from "./ServiceSummary.vue?vue&type=script&lang=js&"
export * from "./ServiceSummary.vue?vue&type=script&lang=js&"
import style0 from "./ServiceSummary.vue?vue&type=style&index=0&id=bf6bcc1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf6bcc1a",
  null
  
)

export default component.exports